import SalesModalComponent from './SalesModal';

export { SalesModalComponent as SalesModal };
export { useSalesModal } from './SalesModal.hooks';
export * from './SalesModal.styles';

export default SalesModalComponent;
